export default class Search extends HTMLFormElement {
    constructor() {
        super();
    }

    connectedCallback() {
        //On controle que l'on est sur la page de recherche
        const searchPage = document.getElementsByClassName('page-search');
        if (searchPage.length > 0) {
            this.initSearch();
        }
    }

    initSearch(){
        /**
         * Differents templates reloadable
         * @type {string}
         */
        this.TEMPLATE_PRODUCTS = 'products';
        this.TEMPLATE_NEWS = 'news';
        this.TEMPLATE_CMS = 'cms';
        this.TEMPLATE_OLD_PRODUCTS = 'old_products';
        this.TEMPLATE_RECETTES = 'recettes';

        /**
         * Containers
         * @type {string}
         */
        this.productsContainerId = '#products-container';
        this.newsContainerId = '#news-container';
        this.cmsContainerId = '#cms-container';
        this.oldProductsContainerId = '#old-products-container';
        this.recettesContainerId = '#recettes-container';

        /**
         * Current selected filters
         * @type {{}}
         */
        this.selectedFilters = {};

        /**
         * Full hash value (with hashtag #)
         * @type {string}
         */
        this.hashCurrent = null;

        /**
         * Hash value without # (hashtag)
         * Used as key in javascript object to store/recover cache
         * @type {string}
         */
        this.hashKey = null;

        /**
         * To store already retrieved content
         * @type {{object}}
         */
        this.cache = {};

        /**
         * Default  filters values
         * @type {number}
         */
        this.productsPage = 1;
        this.productsQuantity = 12;
        this.productsOrder = 1;

        this.newsPage = 1;
        this.newsQuantity = 12;
        this.newsOrder = 1;

        this.cmsPage = 1;
        this.cmsQuantity = 12;
        this.cmsOrder = 1;

        this.oldProductsPage = 1;
        this.oldProductsQuantity = 12;
        this.oldProductsOrder = 1;

        this.recettesPage = 1;
        this.recettesQuantity = 12;
        this.recettesOrder = 1;

        /**
         * Regex
         */
        this.productsPageRegex = /\#?\&?p=(\d+)/i;
        this.productsQuantityRegex = /\#?\&?q=(\d+)/i;
        this.productsOrderRegex = /\#?\&?t=(\d+)/i;

        this.newsPageRegex = /\#?\&?pn=(\d+)/i;
        this.newsQuantityRegex = /\#?\&?qn=(\d+)/i;
        this.newsOrderRegex =  /\#?\&?tn=(\d+)/i;

        this.cmsPageRegex = /\#?\&?pcm=(\d+)/i;
        this.cmsQuantityRegex = /\#?\&?qcm=(\d+)/i;
        this.cmsOrderRegex =  /\#?\&?tcm=(\d+)/i;

        this.oldProductsPageRegex = /\#?\&?pop=(\d+)/i;
        this.oldProductsQuantityRegex = /\#?\&?qop=(\d+)/i;
        this.oldProductsOrderRegex = /\#?\&?top=(\d+)/i;

        this.recettesPageRegex = /\#?\&?rp=(\d+)/i;
        this.recettesQuantityRegex = /\#?\&?rq=(\d+)/i;
        this.recettesOrderRegex = /\#?\&?rt=(\d+)/i;

        this.bind();
    }

    bind() {
        this.initEvents();
        this.updateContentFromHash();
    }

    /**
     * Return jQuery container
     * @param containerId
     * @returns {*|jQuery|HTMLElement}
     */
    getContainer(containerId) {
        const $container = $(containerId);

        if ($container !== undefined && $container.length > 0)
            return $container;
        else {
            return undefined;

            console.error('Container not found - Id : ' + containerId);
        }
    }

    getProductsContainer() {
        return this.getContainer(this.productsContainerId);
    }

    getNewsContainer() {
        return this.getContainer(this.newsContainerId);
    }

    getCmsContainer() {
        return this.getContainer(this.cmsContainerId);
    }

    getOldProductsContainer() {
        return this.getContainer(this.oldProductsContainerId);
    }

    getRecettesContainer() {
        return this.getContainer(this.recettesContainerId);
    }

    /**
     * Analyse hash, and update content with hash params
     */
    updateContentFromHash() {
        this.hashCurrent = window.location.hash;
        this.hashKey = this.hashCurrent.replace(/^#/, '');

        // Update current page from current hash
        this.updatePaginationFromHash();

        this.updateQuantityFromHash();

        this.updateOrderFromHash();

        this.getCurrentProductsContent();
    }

    /**
     * Update CurrentPage using current URL hash
     */
    updatePaginationFromHash() {
        let match;

        if (match = this.productsPageRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.productsPage = match[1];
        }

        if (match = this.newsPageRegex.exec(this.hashCurrent)) {
            // Update the news current page
            this.newsPage = match[1];
        }

        if (match = this.cmsPageRegex.exec(this.hashCurrent)) {
            // Update the cms current page
            this.cmsPage = match[1];
        }

        if (match = this.oldProductsPageRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.oldProductsPage = match[1];
        }

        if (match = this.recettesPageRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.recettesPage = match[1];
        }
    }

    /**
     * Update Quantity using current URL hash
     */
    updateQuantityFromHash() {
        let match;

        if (match = this.productsQuantityRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.productsQuantity = match[1];
        }

        if (match = this.newsQuantityRegex.exec(this.hashCurrent)) {
            // Update the news current page
            this.newsQuantity = match[1];
        }

        if (match = this.cmsQuantityRegex.exec(this.hashCurrent)) {
            // Update the cms current page
            this.cmsQuantity = match[1];
        }

        if (match = this.oldProductsQuantityRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.oldProductsQuantity = match[1];
        }

        if (match = this.recettesQuantityRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.recettesQuantity = match[1];
        }
    }

    /**
     * Update Order using current URL hash
     */
    updateOrderFromHash() {
        let match;

        if (match = this.productsOrderRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.productsOrder = match[1];
        }

        if (match = this.newsOrderRegex.exec(this.hashCurrent)) {
            // Update the news current page
            this.newsOrder = match[1];
        }

        if (match = this.cmsOrderRegex.exec(this.hashCurrent)) {
            // Update the cms current page
            this.cmsOrder = match[1];
        }

        if (match = this.oldProductsOrderRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.oldProductsOrder = match[1];
        }

        if (match = this.recettesOrderRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.recettesOrder = match[1];
        }
    }

    /**
     * Retrieve the content adapted to the current selected filters
     */
    getCurrentProductsContent(templates) {
        if (typeof templates === 'undefined') {
            templates = [
                this.TEMPLATE_PRODUCTS,
                this.TEMPLATE_NEWS,
                this.TEMPLATE_CMS,
                this.TEMPLATE_OLD_PRODUCTS,
                this.TEMPLATE_RECETTES,
            ];
        }

        // Check if cache content exist
        if (this.isCurrentFilterCached(templates)) {
            // If it does, then show the cached content
            this.updateContent(templates);
        } else {
            // If not, then request for content and cache it
            this.sendFilterRequest(templates);
        }
    }

    /**
     * Check if system has already load the current requested hashKey
     * @returns {boolean}
     */
    isCurrentFilterCached(templates) {
        let isCached = true;

        if (!this.cache.hasOwnProperty(this.hashKey)) {
            this.cache[this.hashKey] = {};
            isCached = false;
        }

        $.each(this.cache[this.hashKey], function (key, item) {
            if (isCached === false)
                return;

            isCached = $.inArray(key, templates) > -1;
        });

        return isCached;
    }

    /**
     * Save retrieved data into cache object
     * @param content
     * @param templates
     */
    pushCachedData(content, templates) {

        var self = this;

        if (!self.cache.hasOwnProperty(this.hashKey)) {
            self.cache[self.hashKey] = {};
        }


        $.each(templates, function (key, value) {
            if(content.templates) {
                if (content.templates.hasOwnProperty(value)) {
                    self.cache[self.hashKey][value] = content.templates[value];
                }
            }
        });
    }

    /**
     * Update the content of the page with current hashKey
     */
    updateContent() {
        let data;
        var self = this;

        if (data = this.cache[this.hashKey]) {
            $.each(data, function (key, item) {
                let $container = undefined;

                if (key === self.TEMPLATE_PRODUCTS) {
                    $container = self.getProductsContainer();
                } else if (key === self.TEMPLATE_NEWS) {
                    $container = self.getNewsContainer();
                } else if (key === self.TEMPLATE_CMS) {
                    $container = self.getCmsContainer();
                } else if (key === self.TEMPLATE_OLD_PRODUCTS) {
                    $container = self.getOldProductsContainer();
                } else if (key === self.TEMPLATE_RECETTES) {
                    $container = self.getRecettesContainer();
                }

                if (typeof $container !== 'undefined') {
                    $container.empty().append($(item));
                }
            });
        }

        // Reload listener on favourites stars click
        // App.initFavourites();
    }

    /**
     * Update hash class params and propagate the new hash into the URL
     */
    updateHash() {
        this.hashKey = '1';

        /*
         * Hash for products
         */
        this.hashKey += '&p=' + this.productsPage;
        this.hashKey += '&q=' + this.productsQuantity;
        this.hashKey += '&t=' + this.productsOrder;

        /*
         * Hash for news
         */
        this.hashKey += '&pn=' + this.newsPage;
        this.hashKey += '&qn=' + this.newsQuantity;
        this.hashKey += '&tn=' + this.newsOrder;

        /*
         * Hash for cms
         */
        this.hashKey += '&pcm=' + this.cmsPage;
        this.hashKey += '&qcm=' + this.cmsQuantity;
        this.hashKey += '&tcm=' + this.cmsOrder;

        /*
         * Hash for old products
         */
        this.hashKey += '&pop=' + this.oldProductsPage;
        this.hashKey += '&qop=' + this.oldProductsQuantity;
        this.hashKey += '&top=' + this.oldProductsOrder;

        /*
         * Hash for recettes
         */
        this.hashKey += '&rp=' + this.recettesPage;
        this.hashKey += '&rq=' + this.recettesQuantity;
        this.hashKey += '&rt=' + this.recettesOrder;

        window.location.hash = '#' + this.hashKey;
    }

    /**
     * Build current url
     * @returns {string}
     */
    buildUrl() {
        let url = window.location.origin + window.location.pathname;

        let search = window.location.search;

        if (!search) {
            search = '?1';
        }

        url += search;

        return url;
    }

    /**
     * Send request with template required to response,
     * filters, pages, orders, quantities
     * @param templates Templates required to json response
     */
    sendFilterRequest(templates) {
        var self = this;
        let $container;

        $.each(templates, function (key, value) {
            if (value === this.TEMPLATE_PRODUCTS) {
                $container = this.getProductsContainer();
            } else if (value === this.TEMPLATE_NEWS) {
                $container = this.getNewsContainer();
            } else if (value === this.TEMPLATE_CMS) {
                $container = this.getCmsContainer();
            } else if (value === this.TEMPLATE_OLD_PRODUCTS) {
                $container = this.getOldProductsContainer();
            } else if (value === this.TEMPLATE_RECETTES) {
                $container = this.getRecettesContainer();
            }
        });

        if (typeof $container !== 'undefined') {
            $container.empty().append($('.loader-template').clone().children());
        }

        $.ajax({
            url: this.buildUrl(),
            data: {
                templates: templates,
                p: this.productsPage,
                q: this.productsQuantity,
                t: this.productsOrder,
                pc: this.newsPage,
                qc: this.newsQuantity,
                tc: this.newsOrder,
                pcm: this.cmsPage,
                qcm: this.cmsQuantity,
                tcm: this.cmsOrder,
                pop: this.oldProductsPage,
                qop: this.oldProductsQuantity,
                top: this.oldProductsOrder,
                rp: this.recettesPage,
                rq: this.recettesQuantity,
                rt: this.recettesOrder,
            },
            success: function (data) {
                // Save retrieved data to cache array
                self.pushCachedData(data, templates);
                // Then update content
                self.updateContent();
            }
        });
    }

    /**
     * Update hash url and products contents
     * @param templates
     */
    refreshHashAndContent(templates) {
        this.updateHash();
        this.getCurrentProductsContent(templates);
    }

    /**
     * Init all page events
     */
    initEvents() {
        this.initBlockEvents(this.TEMPLATE_PRODUCTS);
        this.initBlockEvents(this.TEMPLATE_NEWS);
        this.initBlockEvents(this.TEMPLATE_CMS);
        this.initBlockEvents(this.TEMPLATE_OLD_PRODUCTS);
        this.initBlockEvents(this.TEMPLATE_RECETTES);
    }

    /**
     * Init products events
     *
     * @param template
     * @returns {boolean}
     */
    initBlockEvents(template) {
        var self = this;
        let $container = undefined;

        if (template === this.TEMPLATE_PRODUCTS) {
            $container = this.getProductsContainer();
        } else if (template === this.TEMPLATE_NEWS) {
            $container = this.getNewsContainer();
        } else if (template === this.TEMPLATE_CMS) {
            $container = this.getCmsContainer();
        } else if (template === this.TEMPLATE_OLD_PRODUCTS) {
            $container = this.getOldProductsContainer();
        } else if (template === this.TEMPLATE_RECETTES) {
            $container = this.getRecettesContainer();
        }

        if (typeof $container === 'undefined') {
            return false;
        }

        let templates = [template];

        $container.on('click', '.pagination a', function (e) {
            e.preventDefault();

            const page = $(this).attr('href').split('page=')[1];

            if (template === self.TEMPLATE_PRODUCTS) {
                self.productsPage = page;
            } else if (template === self.TEMPLATE_NEWS) {
                self.newsPage = page;
            } else if (template === self.TEMPLATE_CMS) {
                self.cmsPage = page;
            } else if (template === self.TEMPLATE_OLD_PRODUCTS) {
                self.oldProductsPage = page;
            } else if (template === self.TEMPLATE_RECETTES) {
                self.recettesPage = page;
            }

            self.refreshHashAndContent(templates);

            return false;
        })
            .on('change', '.filter-order', function (e) {
                e.preventDefault();

                const order = $(this).val();

                if (template === self.TEMPLATE_PRODUCTS) {
                    self.productsOrder = order;
                } else if (template === self.TEMPLATE_NEWS) {
                    self.newsOrder = order;
                } else if (template === self.TEMPLATE_CMS) {
                    self.cmsOrder = order;
                } else if (template === self.TEMPLATE_OLD_PRODUCTS) {
                    self.oldProductsOrder = order;
                } else if (template === self.TEMPLATE_RECETTES) {
                    self.recettesOrder = order;
                }

                self.refreshHashAndContent(templates);

                return false;
            })
            .on('change', '.filter-quantity', function (e) {
                e.preventDefault();

                const quantity = $(this).val();

                if (template === self.TEMPLATE_PRODUCTS) {
                    self.productsPage = 1;
                    self.productsQuantity = quantity;
                } else if (template === self.TEMPLATE_NEWS) {
                    self.newsPage = 1;
                    self.newsQuantity = quantity;
                } else if (template === self.TEMPLATE_CMS) {
                    self.cmsPage = 1;
                    self.cmsQuantity = quantity;
                } else if (template === self.TEMPLATE_OLD_PRODUCTS) {
                    self.oldProductsPage = 1;
                    self.oldProductsQuantity = quantity;
                } else if (template === self.TEMPLATE_RECETTES) {
                    self.recettesPage = 1;
                    self.recettesQuantity = quantity;
                }

                self.refreshHashAndContent(templates);

                return false;
            });
    }
}
